export const dialogDefault = {
    open: false,
    id: 0,
};

export const DIALOG_AREAPRODUCT = 'DIALOG_AREAPRODUCT';

export const DIALOG_CLIENTE = 'DIALOG_CLIENTE';
export const DIALOG_GRADUACION = 'DIALOG_GRADUACION';
export const DIALOG_CONTACTOLOGIA = 'DIALOG_CONTACTOLOGIA';
export const DIALOG_SMS = 'DIALOG_SMS';
export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';

export const OPEN_DIALOG_RECIBO = 'OPEN_DIALOG_RECIBO';
export const CLOSE_DIALOG_RECIBO = 'CLOSE_DIALOG_RECIBO';

export const DIALOG_LOGIN = 'DIALOG_LOGIN';
export const DIALOG_BILL = 'OPEN_DIALOG_BILL';
export const PAYMENT_BILL = 'PAYMENT_BILL';
export const DIALOG_BILLNOTIFY = 'OPEN_DIALOG_BILLNOTIFY';
export const DIALOG_APPOINTMENT = 'DIALOG_APPOINTMENT';

export const DIALOG_INPUTPRODUCT = 'DIALOG_INPUTPRODUCT';
export const DIALOG_OUTPUTPRODUCT = 'DIALOG_OUTPUTPRODUCT';
export const DIALOG_PURCHASE = 'DIALOG_PURCHASE';

export const OPEN_DIALOG_SCLERAL = 'OPEN_DIALOG_SCLERAL';
export const CLOSE_DIALOG_SCLERAL = 'CLOSE_DIALOG_SCLERAL';

export const OPEN_DIALOG_SCLERALCLIENT = 'OPEN_DIALOG_SCLERALCLIENT';
export const CLOSE_DIALOG_SCLERALCLIENT = 'CLOSE_DIALOG_SCLERALCLIENT';